import { refreshToken, login, getCurrentStaff, userWechatBinding } from '@/api/login'
// 自定义key
import { getToken, setToken, removeToken } from '@/utils/auth'
import common from '@/utils/common'
import { removeWatermark, setWaterMark } from '@/utils/watermark'

function hidePhoneNumber(phoneNumber) {
  // 检查输入是否是数字，并且长度是否为11位
  if (/^\d{11}$/.test(phoneNumber)) {
    // 隐藏中间四位数字
    return phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
  } else {
    // 非法的手机号格式，直接返回原始输入
    return phoneNumber
  }
}

const user = {
  state: {
    token: getToken(),
    user: '',
    status: '',
    code: '',
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: undefined,
    elements: undefined, // roles
    permissionMenus: undefined, // 菜单
    setting: {
      articlePlatform: []
    },
    userData: common.localGetKey('userData')
  },

  mutations: {
    // 写入元素
    SET_ELEMENTS: (state, elements) => {
      state.elements = elements
    },
    // 写入菜单
    SET_PERMISSION_MENUS: (state, permissionMenus) => {
      // 排序
      if (permissionMenus && permissionMenus.length) {
        const compare = (item1, item2) => {
          const sort1 = item1.sort || 0
          const sort2 = item2.sort || 0
          if (sort1 > sort2) {
            return 1
          } else if (sort1 < sort2) {
            return -1
          } else {
            return 0
          }
        }
        const checkout = list => {
          if (list.length) {
            list.sort(compare).forEach(item => {
              if (item.children) {
                checkout(item.children)
              }
            })
          }
        }
        checkout(permissionMenus)
      }
    },
    // 写入用户信息
    SET_USER_DATA: (state, userData) => {
      state.userData = userData
    }
  },

  actions: {
    // 登录
    Login({ commit }, data) {
      commit('SET_ELEMENTS', undefined)
      removeToken()
      common.localDelKey('userData')
      common.localDelKey('time')

      return new Promise((resolve, reject) => {
        login(data).then(res => {
          if (res.status === 200) {
            const { authToken = {}, status } = res.data
            if (status === 0) {
              common.localSetKey('time', common.tockenTime(authToken.expire))
              common.setKey('number', null)
              setToken(authToken.token)
              resolve()
            } else {
              reject(res.data)
            }
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    bindWechat({ commit }, data) {
      return new Promise((resolve, reject) => {
        userWechatBinding(data).then(res => {
          if (res.status === 200) {
            common.localSetKey('time', common.tockenTime(res.data.expire))
            common.setKey('number', null)
            setToken(res.data.token)
            resolve()
          } else {
            reject()
          }
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 获取用户信息
     */
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCurrentStaff().then(res => {
          // 写入用户信息
          commit('SET_ELEMENTS', [])
          commit('SET_USER_DATA', res.data)
          common.localSetKey('userData', JSON.stringify(res.data))
          setWaterMark(hidePhoneNumber(res.data.userPhone), res.data.userName)
          resolve(res)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        removeWatermark()
        commit('SET_ELEMENTS', undefined)
        commit('SET_PERMISSION_MENUS', undefined)
        common.setKey('number', null)
        common.localDelKey('userData')
        common.localDelKey('time')
        common.localDelKey('User-Authorization')
        // 清空所有缓存
        window.sessionStorage.clear()
        // window.localStorage.clear()
        removeToken()
        resolve()
      })
    },

    ChangeTocken({ commit }) {
      return new Promise((resolve, reject) => {
        refreshToken().then(result => {
          setToken(result.data.token)
          common.localSetKey('time', common.tockenTime(result.data.expire))
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
